import clsx from 'clsx'
import ContentLoader from 'react-content-loader'
type Props = {
  className?: string
}
export const LoadingCartPreview = ({ className }: Props) => {
  return (
    <aside className={clsx('w-full', className)}>
      <ContentLoader
        speed={3.3}
        viewBox="0 0 486 150"
        backgroundColor="#F4F4F4"
        foregroundColor="#CACACA"
        gradientRatio={1}
      >
        <circle cx="60" cy="60" r="60" />
        <rect x="144" y="20" rx="0" ry="0" width="200" height="44" />
        <rect x="144" y="80" rx="0" ry="0" width="150" height="20" />
        <rect x="431" y="20" rx="0" ry="0" width="55" height="22" />
        <rect x="431" y="52" rx="0" ry="0" width="55" height="22" />
      </ContentLoader>
    </aside>
  )
}
